(function () {
  var config = Object.assign({
    defaultMode: "navy",
    param: "tk9_cta_color",
    storageKey: "tk9_commerce_cta_color"
  }, window.TeamK9CommerceCTAColorConfig || {});

  function normalizeMode(value) {
    return String(value || "").toLowerCase() === "legacy" ? "legacy" : "navy";
  }

  function storedMode() {
    try {
      return window.localStorage.getItem(config.storageKey);
    } catch (error) {
      return null;
    }
  }

  function persistMode(mode) {
    try {
      window.localStorage.setItem(config.storageKey, normalizeMode(mode));
    } catch (error) {}
  }

  function applyMode(mode) {
    var nextMode = normalizeMode(mode || config.defaultMode);
    document.documentElement.setAttribute("data-tk9-commerce-cta-color", nextMode);
    return nextMode;
  }

  function isHeaderLocalizationControl(node) {
    if (!node || !node.matches || !node.closest("header-component, .header, header")) return false;
    if (node.matches('button[name="add"], [name="checkout"], .product-form__submit, .add-to-cart-button, .cart__checkout-button')) return false;

    var haystack = [
      node.className || "",
      node.id || "",
      node.name || "",
      node.getAttribute("aria-label") || "",
      node.getAttribute("aria-controls") || "",
      node.getAttribute("data-testid") || "",
      node.textContent || ""
    ].join(" ");

    if (/country|currency|locali[sz]ation|locale|region|market/i.test(haystack)) return true;
    if (/\b(USD|CAD|AUD|NZD|GBP|EUR|JPY|MXN)\b/.test(haystack)) return true;
    return !!node.querySelector('[class*="flag" i], img[alt*="flag" i], svg[aria-label*="flag" i]');
  }

  function markHeaderLocalizationControls(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var selector = 'header-component .button, header-component button, .header .button, .header button, header .button, header button';
    var nodes = [];

    if (scope.matches && scope.matches(selector)) nodes.push(scope);
    scope.querySelectorAll(selector).forEach(function (node) {
      nodes.push(node);
    });

    nodes.forEach(function (node) {
      if (isHeaderLocalizationControl(node)) {
        node.setAttribute("data-tk9-localization-control", "true");
      }
    });
  }

  function initHeaderLocalizationControlMarkers() {
    markHeaderLocalizationControls(document);

    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        markHeaderLocalizationControls(document);
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, 20000);
  }

  // REMOVED 2026-07-02: loadCurrentSlideCartRuntime(), a vestigial hotfix
  // injector that appended an OLD-pinned tk9-slide-cart-v2.js copy on every
  // page (its version check compared against a June pin the current drawer
  // never reports). Old generations seize window.TeamK9SlideCart and break
  // flows that call it (PDP patch add). The layout snippet is the ONLY v2
  // loader; the stale-guard owns emergency fallback injection.

  function requestedMode() {
    try {
      var params = new URLSearchParams(window.location.search);
      var value = params.get(config.param);
      if (value === "legacy" || value === "navy") {
        persistMode(value);
        return value;
      }
    } catch (error) {}
    return storedMode() || config.defaultMode;
  }

  function normalizeInventoryPromiseCopy(root) {
    var scope = root && root.nodeType ? root : document.body;
    if (!scope) return;
    var replacements = [
      {
        oldText: "AVAILABLE NOW · Tracked delivery in 5-11 business days",
        newText: "AVAILABLE NOW · Ships direct with tracking"
      },
      {
        oldText: "Tracked delivery in 5-11 business days",
        newText: "Ships direct with tracking"
      }
    ];

    function normalizeTextNode(node) {
      if (!node || node.nodeType !== Node.TEXT_NODE || !node.nodeValue) return;
      var next = node.nodeValue;
      replacements.forEach(function (replacement) {
        next = next.split(replacement.oldText).join(replacement.newText);
      });
      if (next !== node.nodeValue) node.nodeValue = next;
    }

    if (scope.nodeType === Node.TEXT_NODE) {
      normalizeTextNode(scope);
      return;
    }

    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return /Tracked delivery in 5-11 business days|AVAILABLE NOW · Tracked delivery/.test(node.nodeValue || "")
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });
    var node;
    while ((node = walker.nextNode())) normalizeTextNode(node);
  }

  function initInventoryPromiseCopyNormalizer() {
    normalizeInventoryPromiseCopy(document.body);
    if (window.__tk9InventoryPromiseCopyNormalizerLoaded) return;
    window.__tk9InventoryPromiseCopyNormalizerLoaded = true;
    var pending = false;
    var observer = new MutationObserver(function (records) {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        records.forEach(function (record) {
          record.addedNodes && record.addedNodes.forEach(function (node) {
            normalizeInventoryPromiseCopy(node);
          });
        });
        normalizeInventoryPromiseCopy(document.body);
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, 20000);
  }

  function onHardBottomSeatCoverPdp() {
    return /\/products\/hard-bottom-csce(?:[/?#]|$)/.test(window.location.pathname + window.location.search);
  }

  function injectSeatCoverSelectorRecoveryStyles() {
    if (document.getElementById("tk9-seat-cover-selector-recovery-styles")) return;
    var style = document.createElement("style");
    style.id = "tk9-seat-cover-selector-recovery-styles";
    style.textContent = [
      'html[data-tk9-seat-cover-pdp="1"] .swatch-label-container.size-chart-right{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:10px!important;flex-wrap:nowrap!important}',
      'html[data-tk9-seat-cover-pdp="1"] .swatch-label-container.size-chart-right .swatch-label{min-width:0!important;overflow:hidden!important;text-overflow:ellipsis!important;white-space:nowrap!important}',
      'html[data-tk9-seat-cover-pdp="1"] .swatch-label-container.size-chart-right .scr-open-size-chart{align-items:center!important;display:inline-flex!important;flex:0 0 auto!important;font-size:14px!important;line-height:1.1!important;min-height:32px!important;padding:6px 8px!important;white-space:nowrap!important;width:auto!important}',
      'html[data-tk9-seat-cover-pdp="1"] [option-name="Choose a Bundle"] .swatch-label .swatch-variant-name,html[data-tk9-seat-cover-pdp="1"] .swatch-label input[name="Choose a Bundle"]~.swatch-variant-name{display:none!important}',
      '@media(max-width:480px){html[data-tk9-seat-cover-pdp="1"] .swatch-label-container.size-chart-right{gap:8px!important}html[data-tk9-seat-cover-pdp="1"] .swatch-label-container.size-chart-right .scr-open-size-chart{font-size:13px!important;padding:5px 7px!important}}'
    ].join("");
    (document.head || document.documentElement).appendChild(style);
  }

  function normalizeSeatCoverSelectorText(root) {
    var scope = root && root.nodeType ? root : document.body;
    if (!scope) return;

    document.documentElement.setAttribute("data-tk9-seat-cover-pdp", "1");
    injectSeatCoverSelectorRecoveryStyles();

    document.querySelectorAll(".swatch-label.swatch-label-image, .swatch-label").forEach(function (label) {
      var text = (label.textContent || "").replace(/\s+/g, " ").trim();
      var bundleInput = label.querySelector('input[name="Choose a Bundle"]');
      if (!bundleInput && !/^Choose a Bundle\s*:/i.test(text)) return;
      var optionName = label.querySelector(".swatch-option-name");
      if (optionName) optionName.textContent = "Choose a Bundle";
      Array.prototype.slice.call(label.querySelectorAll(".swatch-variant-name")).forEach(function (node) {
        node.remove();
      });
      Array.prototype.slice.call(label.childNodes).forEach(function (node) {
        if (node.nodeType === 3) node.textContent = "";
      });
      if (!optionName) label.textContent = "Choose a Bundle";
    });

    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var value = node.nodeValue || "";
        return /Clean Seats,\s*Safe Dog|Add The Plush Bed/i.test(value)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });
    var node;
    while ((node = walker.nextNode())) {
      node.nodeValue = node.nodeValue
        .replace(/Clean Seats,\s*Safe Dog/gi, "Protect My Seats")
        .replace(/Add The Plush Bed/gi, "Add the Plush Bed");
    }
  }

  function initSeatCoverSelectorRecovery() {
    if (!onHardBottomSeatCoverPdp()) return;
    normalizeSeatCoverSelectorText(document.body);
    if (window.__tk9SeatCoverSelectorRecoveryLoaded) return;
    window.__tk9SeatCoverSelectorRecoveryLoaded = true;

    var pending = false;
    var observer = new MutationObserver(function (records) {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        records.forEach(function (record) {
          record.addedNodes && record.addedNodes.forEach(function (node) {
            normalizeSeatCoverSelectorText(node);
          });
        });
        normalizeSeatCoverSelectorText(document.body);
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, 30000);

    [250, 900, 1800, 3500, 7000].forEach(function (delay) {
      window.setTimeout(function () {
        normalizeSeatCoverSelectorText(document.body);
      }, delay);
    });
  }

  window.TeamK9CommerceCTAColor = {
    mode: function () {
      return document.documentElement.getAttribute("data-tk9-commerce-cta-color") || normalizeMode(requestedMode());
    },
    useLegacy: function () {
      persistMode("legacy");
      return applyMode("legacy");
    },
    useNavy: function () {
      persistMode("navy");
      return applyMode("navy");
    },
    reset: function () {
      try {
        window.localStorage.removeItem(config.storageKey);
      } catch (error) {}
      return applyMode(config.defaultMode);
    }
  };

  applyMode(requestedMode());
  window.setTimeout(initInventoryPromiseCopyNormalizer, 0);
  window.setTimeout(initInventoryPromiseCopyNormalizer, 900);
  window.setTimeout(initInventoryPromiseCopyNormalizer, 2600);
  window.setTimeout(initSeatCoverSelectorRecovery, 0);
  window.setTimeout(initSeatCoverSelectorRecovery, 900);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initHeaderLocalizationControlMarkers();
      initSeatCoverSelectorRecovery();
    }, { once: true });
  } else {
    initHeaderLocalizationControlMarkers();
    initSeatCoverSelectorRecovery();
  }
})();
